/* Bobblery — PDP photo upload (multi-select, native line item properties).
   One visible multi-select picker; the chosen files are distributed into UNIQUE-named
   hidden file inputs (properties[Photo 1], properties[Photo 2], …) because Shopify line
   item properties need a unique name per file — array-style properties[Photos][] is not
   reliable. Shopify's AJAX /cart/add.js can't take files, so product-form.js submits the
   form natively (multipart) when a file is attached. This script also enforces per-file
   size + total-count limits with friendly messages, and lets the shopper remove files. */
(function () {
  var CAN_SET_FILES = typeof DataTransfer !== 'undefined';

  function init(box) {
    var picker = box.querySelector('.bobblery-file__picker');
    var list = box.querySelector('.bobblery-file__list');
    var hidden = box.querySelector('.bobblery-file__hidden');
    var errorEl = box.querySelector('.bobblery-file__error');
    if (!picker || !list || !hidden) return;

    var formId = box.dataset.form || '';
    var maxMb = parseFloat(box.dataset.maxMb) || 20;
    var maxBytes = maxMb * 1024 * 1024;
    var maxCount = parseInt(box.dataset.maxCount, 10) || 8;
    var base = (box.dataset.propBase || 'Photo').trim() || 'Photo';

    var files = []; // source of truth

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
    function fmtSize(bytes) {
      return (bytes / 1024 / 1024).toFixed(1) + 'MB';
    }
    function isSame(a, b) {
      return a.name === b.name && a.size === b.size && a.lastModified === b.lastModified;
    }

    function rebuild() {
      // 1) visible list
      list.innerHTML = '';
      files.forEach(function (file, i) {
        var li = document.createElement('li');
        li.className = 'bobblery-file__item';

        var nameSpan = document.createElement('span');
        nameSpan.className = 'bobblery-file__name';
        nameSpan.textContent = file.name + ' (' + fmtSize(file.size) + ')';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bobblery-file__remove';
        btn.setAttribute('aria-label', 'Remove ' + file.name);
        btn.textContent = '✕';
        btn.addEventListener('click', function () {
          files.splice(i, 1);
          clearError();
          rebuild();
        });

        li.appendChild(nameSpan);
        li.appendChild(btn);
        list.appendChild(li);
      });
      list.hidden = files.length === 0;

      // 2) hidden unique-named inputs that actually submit
      hidden.innerHTML = '';
      if (CAN_SET_FILES) {
        files.forEach(function (file, i) {
          var input = document.createElement('input');
          input.type = 'file';
          input.name = 'properties[' + base + ' ' + (i + 1) + ']';
          input.className = 'bobblery-file__submit-input';
          if (formId) input.setAttribute('form', formId);
          var dt = new DataTransfer();
          dt.items.add(file);
          input.files = dt.files;
          hidden.appendChild(input);
        });
      }
    }

    function addFiles(fileList) {
      var incoming = Array.prototype.slice.call(fileList);
      var rejectedBig = [];
      var hitLimit = false;

      incoming.forEach(function (file) {
        if (files.length >= maxCount) {
          hitLimit = true;
          return;
        }
        if (file.size > maxBytes) {
          rejectedBig.push(file.name + ' (' + fmtSize(file.size) + ')');
          return;
        }
        var dup = files.some(function (f) {
          return isSame(f, file);
        });
        if (!dup) files.push(file);
      });

      if (rejectedBig.length) {
        showError(
          'Skipped ' +
            rejectedBig.join(', ') +
            ' — over the ' +
            maxMb +
            'MB per-photo limit. Pick a smaller image, or choose “After checkout” and we’ll email you an upload link.'
        );
      } else if (hitLimit) {
        showError('You can add up to ' + maxCount + ' photos here. Extra photos can be sent after checkout.');
      } else {
        clearError();
      }

      rebuild();
    }

    picker.addEventListener('change', function () {
      if (picker.files && picker.files.length) addFiles(picker.files);
      picker.value = ''; // reset so re-selecting the same file fires change again
    });

    if (!CAN_SET_FILES) {
      // Extremely old browser: fall back to a single named input so at least one photo works.
      picker.name = 'properties[' + base + ' 1]';
      if (formId) picker.setAttribute('form', formId);
    }
  }

  function boot() {
    document.querySelectorAll('.bobblery-uploads[data-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
